define('app/views/customer_profile_password_view',['app/setup', 'app/models/customer',
  'app/views/gender_selector_view'],
  function(takhfifan, Customer, genderView) {

  takhfifan.CustomerProfilePasswordView = Backbone.View.extend({

    el: $('.tkh-customer-profile-password'),

    events: {
      'click .change_password': 'change_password'
    },

    initialize: function(options) {
      var _this = this;
      this.model = options.model;

      takhfifan.eventHub.on('formkey', function(formKey) {
        _this.model.set('form_key', formKey);
      }, this);

      takhfifan.eventHub.on('customer_profile_password:error', function(errors) {
        _this.passwordErrors(errors);
      }, this);
      takhfifan.eventHub.on('customer_profile_password:success', function(errors) {
        _this.emptyPasswordErrors();
      }, this);

      Backbone.Validation.bind(this);
    },

    emptyPasswordErrors: function() {
      var $errors = this.$('.password-error').empty();
    },

    passwordErrors: function(errors) {
      this.$('.success').empty().hide();
      var $errors = this.$('.password-error');
      $errors.empty();
      _.each(errors, function(e) {
        var preFormattedError='<div class="alert alert-red"><span class="icon-info"></span><p>'+
          e
        '</p></div>';
        var $li = $('<li></li>');
        $li.html(preFormattedError);
        $errors.append($li);
      });
      $errors.show();
    },


    saved_slot: function(data) {
      this.$('.tkh-error').remove();
      this.$('.alert-error').hide();
      this.$('.invalid').removeClass('invalid');
      this.$('.error').removeClass('error');

      takhfifan.eventHub.trigger('message:show', { msg: 'پروفایل با موفقیت ویرایش  شد.',
       classes: 'success alert-green' });
    },

    clearMessages: function() {
      this.$('.password-error').empty();
    },

    change_password: function(e){
      e.preventDefault(e);
      var save_url = this.$el.data('password-save');

      var data = takhfifan.Helper.serializeToObject(this,
        undefined,
        { except: ['gender', 'firstname', 'lastname', 'email'] });

      this.model.set(data, { validate: true });

      if (this.model.isValid()) {
        var url = this.$el.data('submit-to');
        var form = $('.tkh-customer-profile');

        this.model.save(save_url);

      } else {
        e.preventDefault();
        this.$('.password-error').slideDown();
      }
      this.$("#pass1,#pass2,#pass3").val('');

    }
  });

});

